import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';

const LocationIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C12 21 5 13.9375 5 9.5C5 6.18629 8.13401 3.5 12 3.5C15.866 3.5 19 6.18629 19 9.5C19 13.9375 12 21 12 21Z" stroke="#FF7A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="10" r="2.5" stroke="#FF7A1A" strokeWidth="2"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 3.5H9L10 7L8.5 8.5C9.57096 10.5709 11.4291 12.429 13.5 13.5L15 12L18 13V15.5C18 16.0523 17.5523 16.5 17 16.5C11.201 16.5 6.5 11.799 6.5 6C6.5 5.44772 6.94772 5 7.5 5H10V3.5C10 2.94772 9.55228 2.5 9 2.5H7.5C6.94772 2.5 6.5 2.94772 6.5 3.5Z" stroke="#FF7A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="#FF7A1A" strokeWidth="2"/>
    <path d="M3 7L12 13L21 7" stroke="#FF7A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const handleLinkClick = () => {
    closeMobileMenu();
  };

  const handleAboutClick = (e) => {
    e.preventDefault();
    closeMobileMenu();
    window.location.href = '/#about';
  };

  return (
    <header>
      <div className="container">
        <div className="row align-items-center pt-2 pb-2">
          <div className="col-lg-5 col-12 d-none d-lg-block">
            <nav>
              <ul className="nav">
                <li className="nav-item">
                  <Link to="/" className="nav-link">Home</Link>
                </li>
                <li className="nav-item">
                  <a href="/#about" className="nav-link" onClick={handleAboutClick}>About</a>
                </li>
                <li className="nav-item">
                  <Link to="/ice-cream" className="nav-link">Ice Cream</Link>
                </li>
              </ul>
            </nav>
          </div>

          <div className="col-lg-2 col-md-4 col-5 text-start text-lg-center position-relative mt-2 mt-lg-0">
            <div className="d-block text-center">
              <h1 style={{ margin: 0 }}>
                <Link to="/">
                  <img
                    src={process.env.PUBLIC_URL + '/assets/nlo.png'}
                    alt="Kwality Logo"
                    className="combined-logo-img"
                  />
                </Link>
              </h1>
            </div>
          </div>

          <div className="col-lg-5 col-md-8 col-7 d-flex justify-content-end align-items-center">
            <div className="hamburger-menu " onClick={toggleMobileMenu}>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <nav className="d-none d-lg-block">
              <ul className="nav justify-content-end">
                <li className="nav-item">
                  <Link to="/novelties" className="nav-link">Novelties</Link>
                </li>
                <li className={`nav-item dropdown ${activeDropdown === 'order' ? 'show' : ''}`}>
  <a
    href="#"
    className="nav-link dropdown-toggle"
    onClick={(e) => {
      e.preventDefault();
      toggleDropdown('order');
    }}
  >
    Order Online
  </a>
  <ul className={`dropdown-menu ${activeDropdown === 'order' ? 'show' : ''}`}>
    <li><Link to="/order/euless" className="dropdown-item" onClick={closeMobileMenu}>Order Now - Euless</Link></li>
    <li><Link to="/order/frisco" className="dropdown-item" onClick={closeMobileMenu}>Order Now - Frisco</Link></li>
    <li><Link to="/order/irving" className="dropdown-item" onClick={closeMobileMenu}>Order Now - Irving</Link></li>
  </ul>
</li>

                <li className="nav-item">
                  <Link to="/contact" className="nav-link">Contact</Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <>
          <div className="mobile-menu-backdrop" onClick={closeMobileMenu}></div>
          <div className="mobile-menu-overlay">
            <div className="mobile-menu-header">
              
              <button className="mobile-menu-close" onClick={closeMobileMenu}>&times;</button>
            </div>
            <ul className="mobile-menu-list">
              <li><Link to="/" onClick={handleLinkClick} className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
              <li><a href="/#about" onClick={handleAboutClick} className={(location.pathname === '/' && location.hash === '#about') ? 'active' : ''}>About</a></li>
              <li><Link to="/ice-cream" onClick={handleLinkClick} className={location.pathname === '/ice-cream' ? 'active' : ''}>Ice Cream</Link></li>
              <li><Link to="/novelties" onClick={handleLinkClick} className={location.pathname === '/novelties' ? 'active' : ''}>Novelties</Link></li>
              <li className={`mobile-menu-dropdown ${activeDropdown === 'order' ? 'open' : ''}`}> 
                <button 
                  onClick={() => toggleDropdown('order')} 
                  className={`mobile-menu-dropdown-btn${(activeDropdown === 'order' || location.pathname.startsWith('/order')) ? ' active' : ''}`}
                >
                  Order Online <span className="dropdown-arrow">&#9662;</span>
                </button>
                {activeDropdown === 'order' && (
                  <ul className="mobile-menu-dropdown-list">
                    <li><Link to="/order/euless" onClick={handleLinkClick} className={location.pathname === '/order/euless' ? 'active' : ''}>Order Now - Euless</Link></li>
                    <li><Link to="/order/frisco" onClick={handleLinkClick} className={location.pathname === '/order/frisco' ? 'active' : ''}>Order Now - Frisco</Link></li>
                    <li><Link to="/order/irving" onClick={handleLinkClick} className={location.pathname === '/order/irving' ? 'active' : ''}>Order Now - Irving</Link></li>
                  </ul>
                )}
              </li>
              <li><Link to="/contact" onClick={handleLinkClick} className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>
            </ul>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
